import React from "react";
import { Modal } from "antd";
import { X } from "lucide-react";
import { ScannedItemBanner } from "./ScannedItemBanner";
import { ScannerReticle } from "./ScannerReticle";
import { TorchToggleButton } from "./TorchToggleButton";
import { useBarcodeScanner } from "../../Hook";


interface BarcodeScannerModalProps {
  open: boolean;
  onClose: () => void;
  onScanSuccess: (scannedCode: string) => Promise<boolean | void> | boolean | void;
  onIncrement?: (code: string, newQty: number) => void;
  onDecrement?: (code: string, newQty: number) => void;
  title?: string;
  autoCloseOnSuccess?: boolean;
}

export const BarcodeScannerModal: React.FC<BarcodeScannerModalProps> = ({
  open,
  onClose,
  onScanSuccess,
  onIncrement,
  onDecrement,
  autoCloseOnSuccess = false,
}) => {
  const {
    videoRef,
    isScanning,
    lastScanned,
    hasTorch,
    torchOn,
    toggleTorch,
    stopScanner,
  } = useBarcodeScanner({
    open,
    onClose,
    onScanSuccess,
    autoCloseOnSuccess,
  });

  const handleClose = () => {
    stopScanner();
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      title={null}
      closeIcon={null}
      footer={null}
      destroyOnClose
      centered
      width="95vw"
      style={{ maxWidth: "550px", padding: 0 }}
      styles={{
        content: {
          padding: 0,
          backgroundColor: "#000",
          borderRadius: "24px",
          overflow: "hidden",
        },
        body: { padding: 0 },
      }}
    >
      <div className="relative w-full h-[75vh] bg-black flex items-center justify-center overflow-hidden">
        <video
          ref={videoRef}
          className="w-full h-full object-cover"
          playsInline
          muted
          autoPlay
        />

        <ScannerReticle isScanning={isScanning} />

        <TorchToggleButton
          hasTorch={hasTorch}
          torchOn={torchOn}
          onToggle={toggleTorch}
        />

        <button
          onClick={handleClose}
          className="absolute top-4 right-4 z-50 p-2 rounded-full bg-white/80 hover:bg-white text-slate-700 hover:text-slate-900 backdrop-blur-md shadow-md border border-slate-200/80 transition-all active:scale-95 cursor-pointer"
        >
          <X className="w-5 h-5" />
        </button>

        <ScannedItemBanner
          lastScanned={lastScanned}
          onIncrement={onIncrement}
          onDecrement={onDecrement}
        />
      </div>
    </Modal>
  );
};
